import { makeStyles, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';
import { vt } from '../theme';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '34px',
    minHeight: '36px',
    flexShrink: 0,
  },
  // The mockups set screen titles in the brand display cut, caps and tracked out. The console
  // does not ship that face, so this is the closest Inter can get: caps, light, tracked +6%.
  title: {
    margin: 0,
    fontSize: '22px',
    lineHeight: '28px',
    fontWeight: tokens.fontWeightRegular,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: vt.fg1,
  },
  middle: { flexGrow: 1, display: 'flex', alignItems: 'center', minWidth: 0 },
  actions: { display: 'flex', alignItems: 'center', columnGap: '8px', flexShrink: 0 },
});

/** A screen's title row: the title, then whatever sits beside it (tabs), then the actions at the right. */
export function PageHeader({ title, children, actions }: { title: string; children?: ReactNode; actions?: ReactNode }) {
  const s = useStyles();
  return (
    <header className={s.header}>
      <h1 className={s.title}>{title}</h1>
      <div className={s.middle}>{children}</div>
      {actions && <div className={s.actions}>{actions}</div>}
    </header>
  );
}
